export default "__VITE_ASSET__BYACoHFz__"